import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ServiceDetail from "./pages/ServiceDetail";
import Fees from "./pages/Fees";
import News from "./pages/News";
import PostDetail from "./pages/PostDetail";
import FloatingBook from "./components/FloatingBook";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/fees" element={<Fees />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<PostDetail />} />
        </Routes>
        <FloatingBook />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
